/*
 * usePartnerProfile is a custom hook that provides the partner profile. It's an
 * alternative to using the PartnerProfile entity. They are two separate
 * front-end data streams and only crosses when they save data to the server.
 * Choose between the two based on which code you are working on. If you are
 * working on something that depends on the PartnerProfile entity, do not expect
 * updating the profile via the hook to update the entity. On the other hand,
 * the usePartnerProfile hook can pick up update made by the PartnerProfile
 * entity because the hook refectches the profile from the server proactively.
 *
 * Be mindful that usePartnerProfile needs to be wraapped in a
 * <PartnerProfileProvider> component.
 */
export {
  default as PartnerProfileProvider,
  usePartnerProfile as default,
} from './PartnerProfileProvider';
